export default "__VITE_ASSET__7DfdYWb0__"